import React, {useEffect, useState} from "react";
import {StarIcon} from "@heroicons/react/20/solid";
import {RadioGroup} from "@headlessui/react";
import PopupCart from "./pop-cart";
import AuthService from "../services/auth/auth_service";
import {toast, ToastContainer} from "react-toastify";

import {useNavigate} from "react-router";
import PopConfirm from "./PopConfirm";

const PopupProduct = () => {



    const product = {
  name: 'Basic Tee 6-Pack',
  price: '$192',
  href: '#',
  breadcrumbs: [
    { id: 1, name: 'Men', href: '#' },
    { id: 2, name: 'Clothing', href: '#' },
  ],
  images: [
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-secondary-product-shot.jpg',
      alt: '',
    },
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-tertiary-product-shot-01.jpg',
      alt: 'Model wearing plain black basic tee.',
    },
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-tertiary-product-shot-02.jpg',
      alt: 'Model wearing plain gray basic tee.',
    },
    {
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-02-featured-product-shot.jpg',
      alt: 'Model wearing plain white basic tee.',
    },
  ],
  colors: [
    { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
    { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
    { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
  ],
  sizes: [
    { name: 'XXS', inStock: false },
    { name: 'XS', inStock: true },
    { name: 'S', inStock: true },
    { name: 'M', inStock: true },
    { name: 'L', inStock: true },
    { name: 'XL', inStock: true },
    { name: '2XL', inStock: true },
    { name: '3XL', inStock: true },
  ],
  description:
    'The Basic Tee 6-Pack allows you to fully express your vibrant personality with three grayscale options. Feeling adventurous? Put on a heather gray tee. Want to be a trendsetter? Try our exclusive colorway: "Black". Need to add an extra pop of color to your outfit? Our white tee has you covered.',
  highlights: [
    'Hand cut and sewn locally',
    'Dyed with our proprietary colors',
    'Pre-washed & pre-shrunk',
    'Ultra-soft 100% cotton',
  ],
  details:
    'The 6-Pack includes two black, two white, and two heather gray Basic Tees. Sign up for our subscription service and be the first to get new, exciting colors, like our upcoming "Charcoal Gray" limited release.',
}
const reviews = { href: '#', average: 4, totalCount: 117 }

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}



const [selectedColor, setSelectedColor] = useState(product.colors[0])
  const [selectedSize, setSelectedSize] = useState(product.sizes[2])



const [name, setName] = useState('')
  const [photo, setPhoto] = useState('')
    const [price, setPrice] = useState('')
     const [idi, setIdi] = useState('')
  const [size, setSize] = useState([])
   const [color, setColor] = useState([])
    const [data, setData] = useState([])

      const [description, setDescription] = useState('')
    const [foc, setIdFoc] = useState('foc')





    useEffect(() => {
    const mainPop = document.getElementById('pop-product');
    const show = (d) => {
      console.log(d)
        setData(d)
        setPhoto(d.photo)
        setName(d.name)
         setIdi(d.id)
        setPrice(d.price)
      setColor(d.colors)
        const sizesArray = d.size.split(",");
    setSize(sizesArray); // Set the array of sizes
console.log(d.colors); // Log the array of sizes
      setDescription(d.description)
            setIdFoc('foc')


      /*  window.scrollTo({ top: 0, behavior: 'smooth' });*/

         mainPop.style.display = 'inherit';

                     mainPop.scrollTop = 0;

    }

    const hide = () => {
      mainPop.style.display = 'none';
    };

    PopupProduct.show = show;
    PopupProduct.hide = hide;

  }, []);


    function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}




const [selectedQuantity, setSelectedQuantity] = useState(1);
       const [clickedSize, setClickedSize] = useState('');

  const handleQuantityChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedQuantity(selectedValue);
  };

  const handleSizeChange = (sizeName) => {
    setClickedSize(sizeName);
  };




    const [showModal, setShowModal] = useState(false);
  const cartToAdd = () => {
    // Check if the selected size is not empty
    if (!clickedSize) {
     setShowModal(true);
      return;
    }

     const data = {
      appUser: localStorage.getItem('uuid'),
      product: idi,
      selectedSize: clickedSize,
      Qty: selectedQuantity,
    };

     console.log("dadadadadadadadadada", data)
    AuthService.cartAddItems(data).then((r=>{
        console.log('add to cart',r.data)

        AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
        .then((response) => {
          console.log('cart data by user', response.data);
          localStorage.setItem('cart_count', response.data.cart_count)
            setSelectedQuantity(1)
            setClickedSize('')
             PopupProduct.hide()
          // Update your local state with the new cart data here
          // Update the overall total price using the function
          // Update the task count using the function
        })

         toast.success('Umefanikiwa kuongeza bidhaa kwenye kikapu chako')

    }))
}


   const buyNow = () => {
     if (!clickedSize) {
     setShowModal(true);
      return;
    }


       PopupProduct.hide()
       PopConfirm.show(data, selectedQuantity, clickedSize)
       setSelectedSize('')
       setClickedSize('')
       setSelectedQuantity(1)

      /* navigate(`/confirm?d=${encodeURIComponent(JSON.stringify(data))}`)*/
      /*navigation('/confirm')*/
}

 window.history.pushState(null, null, window.location.href);
window.onpopstate = function () {
  // Show an alert when the user clicks the back button
  /*alert("Your click browser back button");*/
  PopupProduct.hide()
    setSelectedQuantity(1)

  // You can also redirect the user to a specific page if needed
  // window.location.href = "/your-custom-page";
};

const hidePop = () => {
       PopupProduct.hide()
    setSelectedQuantity(1)

}





  return(
      <div id={'pop-product'}
             onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
           className={'background-color animate-slideInFromTopRight'}
           style={{position:"fixed", top:0, bottom:0,left:0, right:0, zIndex:90, display:"none", overflow:"auto", backgroundColor: localStorage.getItem('selected-theme')==='light'?'hsl(0, 0%, 99%)':'#1D2521'}}>

      <div id={`${foc}`} className="mt-14">

        {/* Image gallery */}
        <div className="mx-auto  max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-x-8 lg:px-8">
          <div style={{visibility:"hidden"}} className="aspect-h-4 aspect-w-3 hidden overflow-hidden rounded-lg lg:block">
            <img

              src={'photo'}
              alt={product.images[0].alt}
              className="h-full w-full object-cover object-center"
            />
          </div>{/*
          <div className="hidden lg:grid lg:grid-cols-1 lg:gap-y-8">
            <div className="aspect-h-2 aspect-w-3 overflow-hidden rounded-lg">
              <img
                src={'photo'}
                alt={product.images[1].alt}
                className="h-full w-full object-cover object-center"
              />
            </div>
            <div className="aspect-h-2 aspect-w-3 overflow-hidden rounded-lg">
              <img
                src={'photo'}
                alt={product.images[2].alt}
                className="h-full w-full object-cover object-center"
              />
            </div>
          </div>*/}
          <div className="aspect-h-5 bg-white aspect-w-4 mt-7 lg:aspect-h-4 lg:aspect-w-3 sm:overflow-hidden sm:rounded-lg">
            <img
              src={photo}
              alt={'photo'}
              className="h-full w-full object-cover object-center "
              style={{
                  filter: 'brightness(1.1) contrast(1.1) saturate(1.3)'
              }}
            />
          </div>
        </div>

        {/* Product info */}
        <div className="mx-auto max-w-2xl px-4 pb-16 pt-10 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">
          <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
            <h1 className="text-2xl font-bold tracking-tight story__title  sm:text-3xl">{name.split('-')[0]}</h1>
          </div>

          {/* Options */}
          <div className="mt-4 lg:row-span-3 lg:mt-0">
            <h2 className="sr-only">Product information</h2>
            <p className="text-3xl tracking-tight products__price ">{price} <span style={{fontSize:'22px'}} className={'text-green-500'}>Tsh</span></p>

            {/* Reviews */}
            <div className="mt-6">
              <h3 className="sr-only">Reviews</h3>
              <div className="flex items-center">
                <div className="flex items-center">
                  {[0, 1, 2, 3, 4].map((rating) => (
                    <StarIcon
                      key={rating}
                      className={classNames(
                        reviews.average > rating ? ' story__title' : ' story__title text-gray-100',
                        'h-5 w-5 flex-shrink-0'
                      )}
                      aria-hidden="true"
                    />
                  ))}
                </div>
                <p className="sr-only">{reviews.average} out of 5 stars</p>
                <a href={reviews.href} className="ml-3 text-sm font-medium text-indigo-600 hover:text-indigo-500">
                  {reviews.totalCount} reviews
                </a>
              </div>
            </div>

            <div className="mt-10">
              {/* Colors */}
             <div className="flex justify-between">
  {/* Left side for color options */}
  {color && color.length > 0 && (
    <div>
      <h3 className="text-sm font-medium story__title">Color</h3>
      <RadioGroup value={selectedColor} onChange={setSelectedColor} className="mt-4">
        <RadioGroup.Label className="sr-only">Choose a color</RadioGroup.Label>
        <div className="flex items-center space-x-3">
          {color.map((color) => (
            <RadioGroup.Option
              key={color.id}
              value={color}
              className={({ active, checked }) =>
                classNames(
                  active && checked ? 'ring ring-offset-1' : '',
                  !active && checked ? 'ring-2' : '',
                  'relative -m-0.5 flex items-center justify-center rounded-full p-0.5 focus:outline-none'
                )
              }
            >
              <RadioGroup.Label as="span" className="sr-only">
                {color.name}
              </RadioGroup.Label>
              <span
                aria-hidden="true"
                className={classNames(
                  'h-8 w-8 rounded-full border border-opacity-10'
                )}
                style={{ backgroundColor: color.color }}
              />
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  )}

  {/* Right side for quantity selector */}
  <div>
  <h3 className="text-sm font-medium story__title">Idadi</h3>
  <select
    value={selectedQuantity}
      onChange={handleQuantityChange}
    className="block w-full mt-2 border border-gray-300 text-gray-800 text-center rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
  >
    {[...Array(8)].map((_, index) => (
      <option key={index} value={index + 1} >
        {index + 1}
      </option>
    ))}
  </select>
</div>
</div>





              {/* Sizes */}
              <div className="mt-10">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-medium story__title">Size</h3>
                  <a href="#" className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                    Size guide
                  </a>
                </div>

               <RadioGroup value={selectedSize} onChange={setSelectedSize} className="mt-4">
  <RadioGroup.Label className="sr-only">Choose a size</RadioGroup.Label>
  <div className="grid grid-cols-4 gap-4 sm:grid-cols-8 lg:grid-cols-4">
    {size.map((sizeName) => ( // Change from size to sizeName
      <RadioGroup.Option
        key={sizeName} // Change from size to sizeName
        value={sizeName} // Change from size to sizeName
        // You can handle the availability logic here if needed
        className={({ active }) =>
          classNames(
            ' bg-white text-gray-900 shadow-sm',
            active ? 'ring-2 ring-indigo-500' : '',
            'group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6'
          )
        }
        onClick={(e)=>{handleSizeChange(sizeName);  e.preventDefault();}}
      >
        {({ active, checked }) => (
          <div >
            <RadioGroup.Label as="span">{sizeName}</RadioGroup.Label> {/* Change from size to sizeName */}
            <span

              className={classNames(
                active ? 'border' : 'border-2',
                checked ? 'border-indigo-500' : 'border-transparent',
                'pointer-events-none absolute -inset-px rounded-md'
              )}
              aria-hidden="true"
            />
          </div>
        )}
      </RadioGroup.Option>
    ))}
  </div>
</RadioGroup>


              </div>

              <button
                  onClick={()=> {cartToAdd()}}
                type="submit"
                className="mt-10 flex w-full items-center justify-center rounded-md border border-transparent bg-black px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >{/*bg-indigo-600*/}
                <i className={'bx bx-cart bx-flashing mr-3'}></i> Hifadhi kwenye kikapu
              </button>

                <button
                    onClick={()=>buyNow()}
                type="submit"
                className="mt-2 flex w-full items-center justify-center rounded-md border border-transparent bg-black px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                    <i className='bx bx-money bx-flashing mr-3'></i> Nunua sasa
              </button>

                <button
                onClick={()=>hidePop()}
                type="submit"
                className="mt-2 flex w-full items-center bx-flashing justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                    <i className='bx bx-arrow-back bx-fade-left mr-3'></i> Rudi nyuma
              </button>
            </div>
          </div>

          <div className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pb-16 lg:pr-8 lg:pt-6">
            {/* Description and details */}
            <div>
              <h3 className="sr-only">Description</h3>

              <div className="space-y-6">
                <p className=" story__title text-base ">{description}</p>
              </div>
            </div>
{/*
            <div className="mt-10">
              <h3 className="text-sm font-medium text-gray-900">Highlights</h3>

              <div className="mt-4">
                <ul role="list" className="list-disc space-y-2 pl-4 text-sm">
                  {product.highlights.map((highlight) => (
                    <li key={highlight} className="text-gray-400">
                      <span className="text-gray-600">{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-10">
              <h2 className="text-sm font-medium text-gray-900">Details</h2>

              <div className="mt-4 space-y-6">
                <p className="text-sm text-gray-600">{product.details}</p>
              </div>
            </div>*/}
          </div>
        </div>
      </div>





          {showModal && (
            <div  className={`fixed inset-0  flex items-center justify-center z-50`}>
                <div className=" p-4 bg-blue-100 w-80 max-w-full rounded-md shadow-lg">
                    <h2 className={'text-center  font-bold text-gray-800'}>Ndugu mteja</h2>
                    <p className={'text-center mt-3 font-bold text-red-800'}>
                            *Chagua size unayohitaji*
                    </p>


                    <div className="mt-5 md:mt-8 w-full flex justify-center">
                        <button onClick={() => setShowModal(false)} className="w-full sm:w-auto border border-gray-800 text-base font-medium text-gray-800 py-5 px-14 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 bg-gray-800 hover:bg-gray-900 text-white">
                            Sawa
                        </button>
                    </div>
                </div>
            </div>

        /*<div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white p-4 w-80 max-w-full rounded-md shadow-lg">
            <p className="text-gray-800 text-center">
              Please select a size before adding to the cart.
            </p>
            <div className="mt-4 flex justify-center">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-800 text-white rounded-md"
              >
                OK
              </button>
            </div>
          </div>
        </div>*/
      )}





    </div>
  )
}
export default PopupProduct;
